import { IAutomationAppComponent } from "../../types";
import { schema, schemaFresh, schemaSupply, schemaExhaust, schemaOutgoing, schemaRecirculation } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { IconFlap } from "./IconFlap";
import { SubplantInsightsPanel } from "../SubPlantInsights";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: IconFlap,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    InsightsPanel: SubplantInsightsPanel,
    createConfig: {
        group: 'SubPlants',
        name: "Flap",
        description: "Flap",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppFresh : IAutomationAppComponent = {
    schema: schemaFresh,
    supportsProcessPanel: false,
    Icon: IconFlap,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig: {
        group: 'SubPlants',
        name: "Fresh Air Flap",
        description: "Fresh Air Flap",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppSupply : IAutomationAppComponent = {
    schema: schemaSupply,
    supportsProcessPanel: false,
    Icon: IconFlap,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig: {
        group: 'SubPlants',
        name: "Supply Air Flap",
        description: "Supply Air Flap",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppExhaust : IAutomationAppComponent = {
    schema: schemaExhaust,
    supportsProcessPanel: false,
    Icon: IconFlap,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig: {
        group: 'SubPlants',
        name: "Exhaust Air Flap",
        description: "Exhaust Air Flap",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppOutgoing : IAutomationAppComponent = {
    schema: schemaOutgoing,
    supportsProcessPanel: false,
    Icon: IconFlap,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig: {
        group: 'SubPlants',
        name: "Outgoing Air Flap",
        description: "Outgoing Air Flap",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppRecirculation : IAutomationAppComponent = {
    schema: schemaRecirculation,
    supportsProcessPanel: false,
    Icon: IconFlap,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig: {
        group: 'SubPlants',
        name: "Recirculation Air Flap",
        description: "Recirculation Air Flap",
        panel: OverviewPanel,
        defaultState: { },
    },
}